module.exports = __webpack_public_path__ + "static/media/ios-paper-plane.8e5a6b4c.svg";